import datapoints from '../datapoints';
import setInboxRuleDiagnosticRequestStatus from './helpers/setInboxRuleDiagnosticRequestStatus';
import getOutlookMigrationDiagnosticsService from '../services/getOutlookMigrationDiagnosticsService';
import { DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import { action } from 'satcheljs/lib/legacy';
/**
 * Generates an inbox rule diagnostic report
 */
export default action('generateInboxRulesDiagnosticReport', datapoints.generateInboxRulesDiagnosticReportDatapoint)(function generateInboxRulesDiagnosticReport(state) {
    setInboxRuleDiagnosticRequestStatus(1 /* Pending */);
    var dataPoint = returnTopExecutingActionDatapoint();
    return getOutlookMigrationDiagnosticsService()
        .then(function (response) {
        if (response) {
            setInboxRuleDiagnosticRequestStatus(2 /* Complete */);
        }
        else {
            dataPoint.endWithError(DatapointStatus.ServerError, new Error('GetOutlookMigrationDiagnostics service request failed'));
            setInboxRuleDiagnosticRequestStatus(3 /* Error */);
        }
    })
        .catch(function (error) {
        dataPoint.endWithError(DatapointStatus.ServerError, error.message);
        setInboxRuleDiagnosticRequestStatus(3 /* Error */);
    });
});
//# sourceMappingURL=generateInboxRulesDiagnosticReport.js.map